<template>
  <div class="home-container">
    <!-- Hero section with integrated header -->
    <section class="hero-section">
      <Header />
      <!-- 使用BannerSlider组件 -->
      <BannerSlider />
    </section>

    <!-- About us section -->
    <section class="about-section">
      <h2 class="section-title">{{ $t('about.title') }}</h2>
      <div class="about-content">
        <div class="about-image">
          <img src="@/assets/images/aboutUs.png" alt="神翼轮胎" class="about-img" />
        </div>
        <div class="about-text">
          <h3 class="about-subtitle">{{ $t('about.brandName') }}</h3>
          <h4 class="about-subtitle-2">{{ $t('about.brandSub') }}</h4>
          <p class="about-description">{{ $t('about.content') }}</p>
          <a @click="$router.push('/about')" class="more-link">{{ $t('about.more') }}</a>
        </div>
      </div>
    </section>

    <!-- Featured products section -->
    <section class="products-section">
      <h2 class="section-title">{{ $t('products.title') }}</h2>

      <!-- 加载状态 -->
      <div v-if="isLoadingProducts" class="loading-container">
        <div class="loading-spinner"></div>
        <p class="loading-text">{{ $t('common.loading') || '加载中...' }}</p>
      </div>

      <!-- 产品卡片 -->
      <div v-else class="product-cards">
        <div v-for="(product, index) in productsToShow" :key="index" class="product-card">
          <div class="product-image">
            <img :src="product.image" :alt="product.name" class="product-img" @error="handleProductImageError" />
          </div>
          <div class="product-header">
            <h3 class="product-name">{{ product.productName }}</h3>
<!--            <span class="product-subtitle">{{ product.subtitle || product.enName }}</span>-->
          </div>
          <p class="product-desc">{{ product.productSellingPoints }}</p>
          <p class="product-long-desc">{{ product.productCarType }}</p>
          <div class="product-footer">
            <a :href="product.jumpUrl" target="_blank" class="product-btn">{{ $t('products.buyNow') }}</a>
            <button class="text-btn details-btn" @click="navigateToProductDetail(product.id)">{{ $t('about.more') }} <span class="btn-arrow">→</span></button>
          </div>
        </div>
      </div>
    </section>

    <!-- Technology section -->
    <section class="tech-section">
      <h2 class="section-title">{{ $t('technology.title') }}</h2>
      <div class="tech-cards-container">
        <div class="tech-cards">
          <div v-for="(tech, index) in technologies" :key="index" class="tech-card">
            <div class="tech-icon">
              <img :src="require(`@/assets/images/s${index + 1}.png`)" alt="" class="tech-icon-image">
            </div>
            <h3 class="tech-title">{{ $t(`technology.tech${index+1}.title`) }}</h3>
            <p class="tech-desc">{{ $t(`technology.tech${index+1}.desc`) }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer Section -->
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
import BannerSlider from '@/components/BannerSlider.vue';

import { getHeaderInfo } from '@/api/home';

export default {
  name: 'HomePage',
  components: {
    Footer,
    Header,
    BannerSlider
  },
  data() {
    return {
      currentLocale: this.$i18n.locale,
      products: [], // 修改为空数组，将通过API获取
      headerInfo: {
        officialWebsiteLogo: '',
        jumpLink: '',
        externalWarIcon: ''
      },
      technologies: [
        { key: 1 }, { key: 2 }, { key: 3 }, { key: 4 }
      ],
      isLoadingProducts: true, // 添加标记指示是否正在加载产品数据
      productLoadError: false, // 标记产品加载是否出错
      logoLoaded: false,
      tuhuLoaded: false,
    };
  },
  mounted() {
    // 获取产品数据
    this.fetchHomeProducts();
    // 获取头部信息
    this.fetchHeaderInfo();
  },
  computed: {
    logoUrl() {
      return this.headerInfo.officialWebsiteLogo
        ? process.env.VUE_APP_IMAGE_URL + this.headerInfo.officialWebsiteLogo
        : '@/assets/images/logo.png';
    },
    tuhuImageUrl() {
      return this.headerInfo.externalWarIcon
        ? process.env.VUE_APP_IMAGE_URL + this.headerInfo.externalWarIcon
        : '@/assets/images/tuhu.jpg';
    },
    formattedJumpLink() {
      const link = this.headerInfo.jumpLink || '';
      // 检查是否以http://或https://开头，如果不是则添加https://
      if (link && !link.startsWith('http://') && !link.startsWith('https://')) {
        return 'https://' + link;
      }
      return link;
    },
    productsToShow() {
      // 只显示最多两个产品
      return this.products.slice(0, 2);
    }
  },
  beforeDestroy() {
    // 清除定时器（如果有的话）
  },
  methods: {
    async fetchHeaderInfo() {
      try {
        const response = await getHeaderInfo();
        if (response && response.data) {
          this.headerInfo = {
            officialWebsiteLogo: response.data.officialWebsiteLogo,
            jumpLink: response.data.jumpLink,
            externalWarIcon: response.data.externalWarIcon
          };
        }
      } catch (error) {
        console.error('Error fetching header info:', error);
      }
    },

    fetchHomeProducts() {
      this.isLoadingProducts = true;
      this.productLoadError = false;

      this.$api.home.getHomeProducts({publishLocation:2})
        .then(response => {
          console.log('产品 API 返回数据结构:', response);
          if (response.rows && response.rows.length > 0) {
            // 只获取最多两个产品
            this.products = response.rows.slice(0, 2).map(product => {
              // 处理产品图片URL
              let imageUrl = product.productImage || product.imgUrl || product.imageUrl || product.image ||
                           product.coverImg || product.coverImage || product.cover ||
                           (product.img && product.img.url);

              // 检查URL是否需要添加基础路径
              if (imageUrl && imageUrl.startsWith('/') && !imageUrl.startsWith('//')) {
                const baseUrl = process.env.VUE_APP_IMAGE_URL || '';
                imageUrl = baseUrl + imageUrl;
              }
              product.image = imageUrl
              return product;
            });

            console.log('从API获取的产品数据:', this.products);
          } else {
            // 如果API返回了响应但没有数据，使用静态数据
            this.productLoadError = true;
            console.error('产品API返回数据为空，使用默认数据');
            this.useDefaultProducts();
          }
        })
        .catch(error => {
          this.productLoadError = true;
          console.error('获取产品列表失败:', error);
          // 加载失败时使用静态数据
          this.useDefaultProducts();
        })
        .finally(() => {
          this.isLoadingProducts = false;
        });
    },
    useDefaultProducts() {
      // 使用默认的静态产品数据
      this.products = [
        {
          id: 1,
          name: this.$t('products.static1.name'),
          subtitle: this.$t('products.static1.subtitle'),
          desc: this.$t('products.static1.desc'),
          longDesc: this.$t('products.static1.longDesc'),
          image: require('@/assets/images/l2.png')
        },
        {
          id: 2,
          name: this.$t('products.static2.name'),
          subtitle: this.$t('products.static2.subtitle'),
          desc: this.$t('products.static2.desc'),
          longDesc: this.$t('products.static2.longDesc'),
          image: require('@/assets/images/l1.png')
        }
      ];
    },
    changeLanguage(locale) {
      this.$i18n.locale = locale;
      this.currentLocale = locale;
      localStorage.setItem('locale', locale);
    },
    handleProductImageError(event) {
      console.error('产品图片加载失败:', event.target.src);
      // 图片加载失败时不显示图片
      event.target.style.display = 'none';
    },
    navigateToProductDetail(id) {
      if (id) {
        this.$router.push(`/product/${id}`);
      } else {
        console.warn('产品ID不存在，无法导航到产品详情页');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/* Variables */
:root {
  --primary-color: #0056b3;
  --secondary-color: #faad14;
  --text-color: #333;
  --light-text: #fff;
  --dark-background: #0056b3;
  --section-padding: 80px 0;
  --border-radius: 4px;
}

/* Responsive breakpoints */
$mobile: 768px;
$tablet: 1024px;
$desktop: 1200px;

/* 加载状态样式 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  width: 100%;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 86, 179, 0.1);
  border-radius: 50%;
  border-top-color: var(--primary-color);
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

.loading-text {
  color: #666;
  font-size: 16px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Common styles */
.home-container {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  font-family: 'OPPOSans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  background-color: #fff;
  color: var(--text-color);
}

/* Header/Navigation styles */
.nav-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  position: absolute;
  top: 20px;
  left: 0;
  z-index: 100;
  padding: 0;
  box-sizing: border-box;
}

.logo {
  z-index: 10;
  position: relative;
  left: 40px;

  .logo-wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;
    transition: opacity 0.3s ease;

    &.loaded {
      .image-placeholder {
        opacity: 0;
      }
      img {
        opacity: 1;
      }
    }

    height: 35px;
    width: auto;
    display: block;
  }

  .logo-image {
    opacity: 0;
    transition: opacity 0.3s ease;
    height: 35px;
    width: auto;
    display: block;
  }
}

.desktop-nav {
  display: flex;
  align-items: center;
  z-index: 10;
  position: absolute;
  right: 40px;
  left: auto;

  ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    padding-left: 30px;

    li {
      margin-right: 30px;

      &:last-child {
        margin-right: 0;
      }

      .home-link {
        &:after {
          width: 100%; /* 默认显示下划线 */
          opacity: 1;
        }
      }

      a {
        color: #141414;
        text-decoration: none;
        font-size: 16px;
        font-weight: 500;
        padding: 8px 0;
        position: relative;
        transition: all 0.3s;

        &:hover,
        &.active,
        &.router-link-active {
          color: #141414;

          &:after {
            width: 100%;
            opacity: 1;
          }
        }

        &:after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 0;
          height: 2px;
          background-color: #FFD100;
          transition: all 0.3s;
          opacity: 0;
        }
      }
    }
  }

  @media (max-width: $mobile) {
    display: none;
  }

  /* 首页位于蓝色区域的特殊处理 */
  &:before {
    content: '';
    position: absolute;
    left: -30px;
    top: 0;
    bottom: 0;
    width: 1px;
  }
}

.header-right {
  display: flex;
  align-items: center;
  margin-left: 30px;
}

.language-selector {
  display: flex;
  align-items: center;
  margin-right: 20px;

  a {
    color: #141414; /* 修改为与导航栏相同的颜色 */
    text-decoration: none;
    font-size: 16px; /* 修改为与导航栏相同的大小 */
    margin: 0 2px;
    opacity: 0.8;
    transition: all 0.3s;

    &:hover,
    &.active {
      opacity: 1;
      color: #141414; /* 保持文字颜色一致 */
    }
  }

  span {
    color: #ccc;
    margin: 0 2px;
  }
}

.btn-login {
  background-color: #faad14;
  border: none;
  color: #141414;
  padding: 6px 15px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  margin-right: 15px;

  &:hover {
    background-color: darken(#faad14, 10%);
  }
}

.tuhu-icon {
  display: flex;
  align-items: center;
}

.tuhu-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  transition: opacity 0.3s ease;

  &.loaded {
    .image-placeholder {
      opacity: 0;
    }
    img {
      opacity: 1;
    }
  }

  width: 40px;
  height: 40px;
  border-radius: 4px;
}

.tuhu-image {
  opacity: 0;
  transition: opacity 0.3s ease;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.loaded .tuhu-image {
  opacity: 1;
}

/* Hero Section */
.hero-section {
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;
}



/* About Section */
.about-section {
  padding: var(--section-padding);
  background-color: #f5f5f5;

  @media (max-width: $mobile) {
    padding: 40px 20px;
  }
}

.about-content {
  display: flex;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);

  @media (max-width: $mobile) {
    flex-direction: column;
  }
}

.about-image {
  flex: 0 0 50%;
  height: 400px;
  position: relative;
  overflow: hidden;

  .about-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    display: block;
  }

  @media (max-width: $mobile) {
    width: 100%;
    height: 250px;
  }
}

.about-text {
  flex: 1;
  padding: 40px;

  .about-subtitle {
    font-size: 22px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
  }
  .about-subtitle-2 {
    font-size: 20px;
    color: #333;
    margin-bottom: 20px;
  }
  .about-description {
    font-size: 16px;
    line-height: 1.8;
    color: #666;
    margin-bottom: 30px;
  }

  .more-link {
    display: inline-block;
    color: var(--primary-color);
    text-decoration: none;
    font-weight: bold;
    font-size: 16px;
    position: relative;

    &:hover {
      text-decoration: underline;
    }

    &:after {
      content: '→';
      margin-left: 5px;
      transition: transform 0.3s;
      display: inline-block;
    }

    &:hover:after {
      transform: translateX(3px);
    }
  }
}

/* Products Section */
.products-section {
  padding: var(--section-padding);
  background-color: #fff;

  @media (max-width: $mobile) {
    padding: 40px 20px;
  }
}

.product-cards {
  display: flex;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
  gap: 30px;

  @media (max-width: $tablet) {
    flex-wrap: wrap;
    justify-content: center;
  }

  @media (max-width: $mobile) {
    flex-direction: column;
    align-items: center;
  }
}

.product-card {
  flex: 1;
  min-width: 280px;
  max-width: 570px;
  border: 1px solid #e8e8e8;
  border-radius: var(--border-radius);
  padding: 30px 20px;
  text-align: left;
  transition: all 0.3s ease;
  background-color: #fff;

  &:hover {
    box-shadow: 0 8px 16px rgba(0,0,0,0.1);
    transform: translateY(-5px);
  }

  @media (max-width: $mobile) {
    max-width: 100%;
    margin-bottom: 20px;
  }
}

.product-image {
  height: 200px;
  margin-bottom: 20px;
  border-radius: var(--border-radius);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F5F5F5;

  .product-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.product-name {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
  text-align: left;
}

.product-subtitle {
  font-size: 16px;
  font-weight: bold;
  color: #666;
  text-align: left;
}

.product-desc {
  font-size: 16px;
  color: #0048A3;
  margin-bottom: 20px;
  min-height: 24px;
  text-align: left;
  font-weight: bold;
}

.product-long-desc {
  font-size: 14px;
  color: #777;
  margin-bottom: 20px;
  line-height: 1.6;
  text-align: left;
  min-height: 100px;
}

.product-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  width: 100%;
  gap: 20px;
}

.product-btn {
  padding: 8px 20px;
  background-color: #FFD100;
  color: #333;
  border: none;
  border-radius: var(--border-radius);
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  min-width: 120px;
  text-align: center;
  text-decoration: none;

  &:hover {
    background-color: darken(#FFD100, 10%);
  }
}

.text-btn {
  background: none;
  border: none;
  color: #666;
  font-weight: 500;
  font-size: 14px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s;

  .btn-arrow {
    margin-left: 5px;
    transition: transform 0.3s;
  }

  &:hover {
    color: #0048A3;

    .btn-arrow {
      transform: translateX(3px);
    }
  }
}

.details-btn {
  color: #666;
}

.slider-dots {
  display: flex;
  justify-content: center;
  margin-top: 40px;

  .dot {
    width: 12px;
    height: 12px;
    background-color: #ccc;
    border-radius: 50%;
    margin: 0 5px;
    cursor: pointer;
    transition: all 0.3s;

    &.active {
      background-color: var(--primary-color);
    }

    &:hover {
      transform: scale(1.1);
    }
  }
}

/* Tech Section */
.tech-section {
  position: relative;
  padding: 46px 0; /* 增加底部padding */
  background-color: var(--dark-background);
  color: var(--light-text);
  overflow: hidden; /* 防止溢出 */
  
  @media (max-width: $mobile) {
    margin: 0;
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
  }

  .section-title {
    color: var(--light-text);

    &:after {
      background-color: var(--secondary-color); /* 修改为黄色下划线 */
    }
  }

  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 35%; /* 调整白色区域高度，使蓝色区域更大 */
    background-color: #fff;
    z-index: 1;
    
    @media (max-width: $mobile) {
      height: 0; /* H5移动端去掉白色背景高度 */
    }
  }

  @media (max-width: $mobile) {
    padding: 40px 0 100px;
  }
}

.tech-subtitle {
  text-align: center;
  max-width: 700px;
  margin: 0 auto 60px; /* 调整底部边距 */
  font-size: 18px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
  position: relative;
  z-index: 2; /* 确保文字在上层 */
  
  @media (max-width: $mobile) {
    padding: 0 20px;
    box-sizing: border-box;
  }
}

.tech-cards-container {
  position: relative;
  z-index: 5; /* 确保卡片在最上层 */
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: $mobile) {
    padding: 0 20px;
    max-width: 100%;
    box-sizing: border-box;
  }
}

.tech-cards {
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 30px;

  @media (max-width: $tablet) {
    flex-wrap: wrap;
    justify-content: center;
  }

  @media (max-width: $mobile) {
    flex-direction: column;
    align-items: center;
  }
}

.tech-card {
  flex: 0 0 calc(25% - 20px);
  min-width: 260px;
  max-width: 280px;
  background-color: #fff;
  border-radius: var(--border-radius);
  padding: 30px 20px;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;

  &:hover {
    transform: translateY(-10px);

    .tech-icon {
      transform: rotate(10deg);
    }
  }

  @media (max-width: $mobile) {
    max-width: 100%;
    margin-bottom: 20px;
  }
}

.tech-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: all 0.3s ease;

  .tech-icon-image {
    width: 56px;
    height: 56px;
    object-fit: contain;
  }
}

.tech-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333; /* 改为深色文字 */
}

.tech-desc {
  font-size: 14px;
  line-height: 1.6;
  color: #666; /* 改为灰色文字 */
}

/* Other section styles */
.section-title {
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 40px;
  position: relative;
  color: #333;
  padding-bottom: 15px;
  display: inline-block;
  margin-left: 50%;
  transform: translateX(-50%);

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background-color: #FFD100;
  }
}

/* Footer Styles - REMOVE ALL FOOTER STYLES */



.empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  width: 100%;
}

.empty-text {
  color: #666;
  font-size: 16px;
}

.image-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(255,209,0,0.05), rgba(255,209,0,0.1), rgba(255,209,0,0.05));
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  transition: opacity 0.3s ease;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

.logo-wrapper,
.tuhu-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  transition: opacity 0.3s ease;

  &.loaded {
    .image-placeholder {
      opacity: 0;
    }
    img {
      opacity: 1;
    }
  }
}

.logo-wrapper {
  height: 35px;
  width: auto;
}

.tuhu-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 4px;
}

.logo-image {
  height: 35px;
  width: auto;
  display: block;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.tuhu-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.loaded .logo-image,
.loaded .tuhu-image {
  opacity: 1;
}


</style>
